const locale = {
  placeholder: 'בחר שעה',
};

export default locale;
